// Navigation-experience Sentry DSN
export const SENTRY_DSN =
	'https://b8c4ebbdd822beb92561fea2a46d2146@o55978.ingest.us.sentry.io/4510463033081856';

export const SENTRY_TEAM_NAME = 'afe-navigation-experience';

/**
 * Known BE / network errors that aren't actionable in the FE.
 * Used by `isSuppressedBackendError` in `beforeSend` and spread into `ignoreErrors`.
 * Gated by feature flag `navx-4946-sentry-filtering`.
 */
export const SUPPRESSED_BACKEND_ERROR_PATTERNS: RegExp[] = [
	// Browser-level network failures
	/Failed to fetch$/i, // Chromium
	/NetworkError when attempting to fetch/i, // Firefox
	/Load failed$/i, // Safari
	/AbortError/i,
	/The user aborted a request/i,
	/^Failed to fetch data:/i,
	/^BFF_NETWORK_ERROR:/i,
	/^RelayNetwork: No data returned for operation/i,
	/^FetchError:/i,
	/^Error getting available products by site/i,
];

export const DEFAULT_SENTRY_CONFIG: {
	attachStacktrace: boolean;
	ignoreErrors: RegExp[];
	ignoreUrls: RegExp[];
	whitelistUrls: RegExp[];
} = {
	whitelistUrls: [/atl-paas.net/, /localhost/],
	ignoreErrors: [/^SentryIgnore:/],
	ignoreUrls: [/extensions\//i, /^chrome:\/\//i],
	attachStacktrace: true,
};

export const SENTRY_PRODUCT = 'navigation';
